export default "__VITE_ASSET__46ef9f65__"